import work from "./work.vue";

export default [
  {
    name: "work",
    path: "/work",
    component: work,
  },
];
